import { createPortal } from "react-dom";

/**
 * Web implementation: renders children into document.body via React portal
 * with fixed positioning based on measured coordinates.
 */
const DropdownPortal = ({ children }) => {
  return createPortal(children, document.body);
};

export default DropdownPortal;
